import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { TrimesterAccMentorWithAccDetails } from '@interfaces';
import { AllMentorsGridPart } from '../../../../../../ui/widget/shared-grids/all-mentors-grid/all-mentors-grid.part';
import { DeliveryOverviewService } from '../../../delivery-overview.service';

@Component({
	selector: 'delivery-all-mentors-view-part',
	standalone: true,
	imports: [AllMentorsGridPart],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './all-mentors-view.part.html',
})
export class DeliveryAllMentorsViewPart {

	private readonly util = inject(UtilityService);
	readonly pageService = inject(DeliveryOverviewService);

	public allMentors = computed<TrimesterAccMentorWithAccDetails[]>(() => {
		const data = this.pageService.areaService.deliveryData();
		if (!data) return [];

		const accById = this.util.array.toMap(data.accelerators, acc => acc.accId);

		return data.allMentors.map(m => {
			const acc = accById[m.accId]!;
			return {
				...m,
				accName: acc.name,
				facilitatorStaffId: acc.facilitatorStaffId
			}
		});
	});

}